import type { FC } from 'react';
import { useNavigate } from 'react-router';
import { ownerContributorAndViewerIds } from 'src/components/form';
import { PageWrapper } from 'src/components/form/form/PageWrapper';
import { useInsertOversightAssessment } from 'src/hooks/mutations/oversight-assessment';
import type { OversightAssessmentFormDataFields } from 'src/pages/assessments/oversight-assessments/forms/oversight-assessment-form/oversightAssessmentSchema';

import { oversightAssessmentDetailsUrl } from '@/utils/urls';

import OversightAssessmentForm from '../../forms/oversight-assessment-form';

const OversightAssessmentCreateTab: FC = () => {
  const navigate = useNavigate();
  const { insertOversightAssessment } = useInsertOversightAssessment();

  const onSave = async (variables: OversightAssessmentFormDataFields) => {
    const data = await insertOversightAssessment({
      CustomAttributeData: variables.CustomAttributeData || undefined,
      ...ownerContributorAndViewerIds(variables),
      TagTypeIds: variables.tags?.map((t) => t.TagTypeId) || [],
      DepartmentTypeIds:
        variables.departments?.map((d) => d.DepartmentTypeId) || [],
      CompletedByUser: variables.CompletedByUser?.value ?? null,
      Status: variables.Status,
      StartDate: variables.StartDate,
      Title: variables.Title,
      Summary: variables.Summary,
      ActualCompletionDate: variables.ActualCompletionDate,
      NextTestDate: variables.NextTestDate,
      TargetCompletionDate: variables.TargetCompletionDate,
      Outcome: variables.Outcome,
      OriginatingItemId: null,
    });
    const result = data?.insertOversightAssessmentApi;
    if (result?.Id) {
      navigate(oversightAssessmentDetailsUrl(result.Id), {
        replace: true,
      });
    }

    return { savedId: result?.Id };
  };

  const onDismiss = (saved?: boolean) => {
    if (!saved) {
      navigate(-1);
    }
  };

  return (
    <OversightAssessmentForm
      onSave={onSave}
      onDismiss={onDismiss}
      renderTemplate={(renderProps) => <PageWrapper {...renderProps} />}
    />
  );
};

export default OversightAssessmentCreateTab;
